import { Spacer } from '@vinted/web-ui';
import useTranslate from 'hooks/useTranslate';
import { NAVIGATION_COOKIES_URL } from 'constants/catalog';
import { BUSINESS_TERMS_OF_SALE_URL, BUSINESS_TERMS_URL, COOKIE_POLICY_URL, HELP_SAFETY_URL, PRIVACY_POLICY_URL, TERMS_URL } from 'constants/routes';
import { toggleOneTrustInfoDisplay } from 'libs/utils/window';
import LinkCell from '../LinkCell';
import LinksGroup from '../LinksGroup';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

const SecondColumn = _ref => {
  let {
    impressumUrl,
    isBusinessAccountLinksVisible
  } = _ref;
  const translate = useTranslate('header.main_navigation.about');

  const handleCookiesClick = event => {
    event.preventDefault();
    toggleOneTrustInfoDisplay();
  };

  return /*#__PURE__*/_jsxs("div", {
    children: [/*#__PURE__*/_jsxs(LinksGroup, {
      title: translate('policies.title'),
      children: [/*#__PURE__*/_jsx(LinkCell, {
        title: translate('policies.items.safety'),
        url: HELP_SAFETY_URL
      }), impressumUrl && /*#__PURE__*/_jsx(LinkCell, {
        title: translate('policies.items.impressum'),
        url: impressumUrl
      }), /*#__PURE__*/_jsx(LinkCell, {
        title: translate('policies.items.privacy_policy'),
        url: PRIVACY_POLICY_URL
      }), /*#__PURE__*/_jsx(LinkCell, {
        title: translate('policies.items.terms_and_conditions'),
        url: TERMS_URL
      }), /*#__PURE__*/_jsx(LinkCell, {
        title: translate('policies.items.cookie_policy'),
        url: COOKIE_POLICY_URL
      }), isBusinessAccountLinksVisible && /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(LinkCell, {
          title: translate('policies.items.pro_terms_of_sale'),
          url: BUSINESS_TERMS_OF_SALE_URL
        }), /*#__PURE__*/_jsx(LinkCell, {
          title: translate('policies.items.pro_terms_of_use'),
          url: BUSINESS_TERMS_URL
        })]
      })]
    }), /*#__PURE__*/_jsx(Spacer, {
      size: Spacer.Size.X2Large
    }), /*#__PURE__*/_jsx(LinksGroup, {
      title: translate('privacy.title'),
      children: /*#__PURE__*/_jsx(LinkCell, {
        title: translate('privacy.items.cookies'),
        url: NAVIGATION_COOKIES_URL,
        onClick: handleCookiesClick,
        testId: "about-panel-cookie-settings-button"
      })
    })]
  });
};

export default SecondColumn;